import React, { useEffect, useMemo, useState, useContext } from 'react';
import { MantineReactTable, useMantineReactTable } from 'mantine-react-table';
import { Button, Card, Container, Group, Title, ActionIcon, Tooltip, Modal, Text, Box, Divider } from '@mantine/core';
import { FaArrowLeft, FaEdit, FaTrash } from 'react-icons/fa';
import AddBatchForm from '../forms/AddBatchForm';
import './Branches.css';
import { getBatch, deleteBatch, addBatches, editBatches } from '../../axios';
import authContext from '../../AuthContext';
import { useNavigate } from 'react-router-dom';

const Batches = () => {
  const [showForm, setShowForm] = useState(false);
  const [data, setData] = useState([]);
  const { user, userType } = useContext(authContext);
  const [editBatch, setEditBatch] = useState(null); // State for editing batch
  const [update, setUpdate] = useState(false); // State to trigger updates
  const [confirmDelete, setConfirmDelete] = useState(false); // State for delete confirmation modal
  const [batchToDelete, setBatchToDelete] = useState(null); // Batch to be deleted
  const navigate = useNavigate();
//(user)
  // Handle add or edit batch form submission
  const handleAddBatch = async(batch) => {
    if (editBatch) {
      // Update the batch
      const batches = { ...batch, id: user }; // 👈 create new batches object
      //console.log(batches)
      const res=await editBatches(batches);
      //console.log(res)
      setUpdate(!update);
      setShowForm(false);
      setEditBatch(null); // Reset edit state
    } else {
      // Add new batch
      const res=await addBatches(batch);
      //(res)
      setUpdate(!update);
      setShowForm(false);
    }
  };
const handleBackClick=()=>{
  setShowForm(false)
  setEditBatch(null); // Reset edit state
}
  // Handle row edit
  const handleEdit = (row) => {
    setEditBatch(row.original);
    setShowForm(true);
  };

  // Handle row delete
  const handleDelete = (row) => {
    setBatchToDelete(row.original);
    setConfirmDelete(true); // Open the confirmation modal
  };

  // Confirm batch deletion
  const confirmDeleteBatch = async() => {
    if (batchToDelete) {
      //console.log(batchToDelete.id)
      const res=await deleteBatch(batchToDelete.id);
      //console.log(res)
    if(res){
      setUpdate(!update); // Trigger data refresh
      setConfirmDelete(false); // Close modal
    }
    }
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: 'serialNumber',
        header: 'No.',
        Cell: ({ row }) => row.index + 1, // Display row number
        size: 60,
      },
      {
        accessorKey: 'batch_id',
        header: 'Batch ID',
      },
      {
        accessorKey: 'course',
        header: 'Course',
      },
      {
        accessorKey: 'admin_name',
        header: 'Admin Name',
      },
      {
        accessorKey: 'branch_id',
        header: 'Branch ID',
      },
      {
        accessorKey: 'strength',
        header: 'Strength',
        Cell: ({ row }) => (
          <Text
            variant="gradient"
            gradient={{ from: 'blue', to: 'cyan', deg: 90 }}
            style={{ cursor: 'pointer' }} // Make it look clickable
            onClick={() =>
              navigate('/student-details', {
                state: { batchId: row.original.id, isBatchStudent: true },
              })
            }
          >
            {`${row.original.students_count}/${row.original.strength}`}
          </Text>
        ),
      },
      ...(userType === 'sa'
        ? [
            {
              accessorKey: 'actions',
              header: 'Actions',
              Cell: ({ row }) => (
                <Group spacing="sm">
                  <Tooltip label="Edit Batch">
                    <ActionIcon color="green" onClick={() => handleEdit(row)}>
                      <FaEdit size={16} />
                    </ActionIcon>
                  </Tooltip>
                  <Tooltip label="Delete Batch">
                    <ActionIcon color="red" onClick={() => handleDelete(row)}>
                      <FaTrash size={16} />
                    </ActionIcon>
                  </Tooltip>
                </Group>
              ),
            },
          ]
        : []), // No actions column for non-'sa' users
    ],
    [userType] // Add userType as a dependency
  );

  useEffect(() => {
  const fetchBatches=async()=>{
    const res=await getBatch(user)
    setData(res.data)
  }
  fetchBatches()
  }, [update, user]); // Add user to dependency array

  const table = useMantineReactTable({
    columns,
    data,
  });

  return (
    <Container size="lg" style={{ marginTop: '20px', padding: '20px' }}>
      {showForm ? (
        <>
          <Group position="left" mb="md">
            <ActionIcon variant="outline" color="gray" onClick={handleBackClick}>
                         <FaArrowLeft size={16} />
                       </ActionIcon>
          </Group>
          <AddBatchForm onSubmit={handleAddBatch} editBatch={editBatch} />
        </>
      ) : (
        <>
          <Group position="apart" mb="md">
            <Title order={2} style={{ color: '#2c7a3b' }}>Batches List</Title>
            {userType === 'sa' && ( // Conditionally render Add Batch button
            <Button variant="outline" color="green" onClick={() => setShowForm(true)}>
                          Add Batch
                        </Button>
            )}
          </Group>

         <Card shadow="sm" padding="lg" radius="md" withBorder>
                    <MantineReactTable table={table} />
                  </Card>
        </>
      )}

      {/* Delete confirmation modal */}
      <Modal
        opened={confirmDelete}
        onClose={() => setConfirmDelete(false)}
        title="Confirm Deletion"
        centered
        overlayColor="rgba(0, 0, 0, 0.5)"
        overlayOpacity={0.5}
        overlayProps={{ blur: 4 }}
        styles={{
          title: {
            color: '#333',
            fontSize: '1.5rem',
          },
        }}
      >
        <Box>
          <Text>Are you sure you want to delete batch {batchToDelete ? batchToDelete.batch_id : ''}?</Text>
          <Group position="right" mt="md">
            <Button
              variant="outline"
              onClick={() => setConfirmDelete(false)}
              style={{
                borderColor: '#ccc',
                color: '#ccc',
                borderRadius: '8px',
                padding: '6px 12px',
              }}
            >
              Cancel
            </Button>
            <Button
              color="red"
              onClick={confirmDeleteBatch}
              style={{
                backgroundColor: '#ff4d4d',
                borderRadius: '8px',
                padding: '6px 12px',
              }}
            >
              Confirm
            </Button>
          </Group>
        </Box>
      </Modal>
    </Container>
  );
};

export default Batches;
